import React from 'react';
import { st, classes } from './Cell.st.css';
import { CellProps } from '../Layout.types';

const Cell: React.FC<CellProps> = ({
  span = 12,
  rows = 1,
  children,
  vertical,
  className,
  dataHook,
}: CellProps) => (
  <div
    data-hook={dataHook}
    style={{
      gridColumn: `span ${span}`,
      gridRow: `span ${rows}`,
    }}
    className={st(classes.root, { vertical }, className)}
    children={children}
  />
);

Cell.displayName = 'Cell';

export { Cell };
